import { SystemType, SystemTypeLabel } from '@/pages/EnergyDispatchManagement/ElementCreationModal/Gateway';
import { apiV2DispatchUetStructPublishGatewayDetailPost } from '@maxtropy/intelligent-dispath-apis-v2';
import { useRequest } from 'ahooks';
import { Descriptions, Drawer, Form, Spin } from 'antd';
import { isNil } from 'lodash-es';
import React, { FC, useState } from 'react';
import styles from './index.module.scss';
import ShowInput from '@/components/ShowInput';
import TitleTag from '../TitleTag';
import { NodeType } from '@/pages/EnergyDispatchManagement/ElementCreationModal/types';

export interface GatewayDrawerProps {
  isShowModal: (open: boolean) => void;
  open: boolean;
  id?: number;
  version?: number;
}

const { Item } = Form;

const GatewayDrawer: FC<GatewayDrawerProps> = props => {
  const { isShowModal, open, id, version } = props;

  const [form] = Form.useForm();
  const [title, setTitle] = useState<string>();

  // 详情
  const { loading } = useRequest(
    async () => {
      const res = await apiV2DispatchUetStructPublishGatewayDetailPost({ id: id!, version });
      setTitle(res.name);
      form.setFieldsValue({
        ...res,
        NodeTypeName: '网关',
        systemType: SystemTypeLabel[res.systemType as SystemType],
      });
    },
    {
      ready: !isNil(id) && !isNil(version) && open,
      refreshDeps: [id, open, version],
    }
  );

  return (
    <div className={styles.drawerStyle}>
      <Drawer
        title={<TitleTag title={title ?? '网关'} nodeType={NodeType.NETWORK} />}
        placement="right"
        width={400}
        mask={false}
        onClose={() => {
          isShowModal?.(false);
        }}
        open={open}
        getContainer={false}
      >
        <Spin spinning={loading}>
          <Form form={form}>
            <Descriptions labelStyle={{ width: '40%' }} title={null} bordered column={1} size="small">
              <Descriptions.Item label="元素类型">
                <Item name="NodeTypeName" style={{ marginBottom: 0 }}>
                  <ShowInput />
                </Item>
              </Descriptions.Item>
              <Descriptions.Item label="网关编号">
                <Item name="serialNumber" style={{ marginBottom: 0 }}>
                  <ShowInput />
                </Item>
              </Descriptions.Item>
              <Descriptions.Item label="网关名称">
                <Item name="name" style={{ marginBottom: 0 }}>
                  <ShowInput />
                </Item>
              </Descriptions.Item>
              <Descriptions.Item label="网关类型">
                <Item name="systemType" style={{ marginBottom: 0 }}>
                  <ShowInput />
                </Item>
              </Descriptions.Item>
            </Descriptions>

            <div className={styles.preview}>
              <div className={styles.previewBtn} style={{ marginTop: 16, marginBottom: 8 }}>
                查看图标
              </div>

              <div className={styles.iconWrapper}>
                <div className={styles.iconBox}>
                  <div className={styles.icon} />
                  <Item noStyle dependencies={['name']}>
                    {({ getFieldValue }) => <div className={styles.iconText}>{getFieldValue('name')}</div>}
                  </Item>
                </div>
              </div>
            </div>
          </Form>
        </Spin>
      </Drawer>
    </div>
  );
};

export default GatewayDrawer;
